import { CalendarProvider } from './CalendarPage.context'
import { CalendarComponent, CalendarDetails } from './components'

export const CalendarPage = () => {
  return (
    <CalendarProvider>
      <CalendarComponent />
      <CalendarDetails />
    </CalendarProvider>
  )
}
